import React, { useContext, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import logo from "../Assets/logo.png";
import { Link, useNavigate } from "react-router-dom";
import { MyContext } from "../Context/MyContext";
import { useMediaQuery } from "@mui/material";
import ThemeToggle from "../components/ThemeToggle/ThemeToggle";

function NavBar() {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);
  const isMobile = useMediaQuery("(max-width:767px)");
  const navigate = useNavigate();
  const { serviceRef, appointmentRef, processRef, aboutUsRef } =
    useContext(MyContext);

  useEffect(() => {
    const scrollHandler = () => {
      updateNavbar(window.scrollY >= 20);
    };
    window.addEventListener("scroll", scrollHandler);
    return () => window.removeEventListener("scroll", scrollHandler);
  }, []);

  useEffect(() => {
    if (!isMobile) {
      updateExpanded(false);
    }
  }, [isMobile]);

  useEffect(() => {
    document.body.style.overflow = expand && isMobile ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [expand, isMobile]);

  const scrollTo = (hash, ref, block = "start") => {
    updateExpanded(false);
    window.location.hash = hash;
    ref?.current?.scrollIntoView({
      behavior: "smooth",
      block,
    });
  };

  const links = [
    { label: "Services", hash: "#services", ref: serviceRef },
    { label: "Process", hash: "#process", ref: processRef },
    { label: "About", hash: "#about", ref: aboutUsRef },
  ];

  const drawer =
    isMobile &&
    createPortal(
      <div className={`mobileDrawer ${expand ? "isOpen" : ""}`} aria-hidden={!expand}>
        <div className="mobileDrawerGlow" />
        <nav className="mobileDrawerNav">
          {links.map((item, index) => (
            <button
              key={item.hash}
              type="button"
              className="mobileDrawerLink"
              style={{ "--i": index }}
              onClick={() => scrollTo(item.hash, item.ref)}
            >
              <span className="mobileDrawerIndex">
                {String(index + 1).padStart(2, "0")}
              </span>
              <span className="mobileDrawerLabel">{item.label}</span>
            </button>
          ))}
        </nav>
        <div className="mobileDrawerFoot">
          <button
            type="button"
            className="buttonHome mobileDrawerCta"
            onClick={() => scrollTo("#book-appointment", appointmentRef)}
          >
            Book a Call
          </button>
          <a className="mobileDrawerEmail" href="mailto:admin@digitalination.com">
            admin@digitalination.com
          </a>
        </div>
      </div>,
      document.body
    );

  return (
    <>
      <Navbar
        expanded={isMobile ? false : expand}
        fixed="top"
        expand="md"
        className={`${navColour ? "sticky" : "navbar"} ${expand ? "menuOpen" : ""}`}
      >
        <Container>
          <Navbar.Brand
            onClick={() => {
              updateExpanded(false);
              navigate("/");
              window.location.hash = "#.";
              window.scrollTo(0, 0);
            }}
            className="d-flex"
          >
            <img src={logo} className="img-fluid logo" alt="" />
            <span className="brandMark">DigitaliNation</span>
          </Navbar.Brand>
          <div className="d-flex align-items-center">
            {isMobile ? <ThemeToggle /> : null}
            <Navbar.Toggle
              aria-controls="responsive-navbar-nav"
              aria-expanded={expand}
              className={expand ? "is-open" : ""}
              onClick={() => {
                updateExpanded((open) => !open);
              }}
            >
              <span></span>
              <span></span>
              <span></span>
            </Navbar.Toggle>
          </div>
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ms-auto" defaultActiveKey="#home">
              {links.map((item) => (
                <Nav.Item key={item.hash}>
                  <Nav.Link
                    as={Link}
                    to={item.hash}
                    onClick={() => scrollTo(item.hash, item.ref)}
                  >
                    {item.label}
                  </Nav.Link>
                </Nav.Item>
              ))}

              {!isMobile ? (
                <Nav.Item className="d-flex align-items-center">
                  <ThemeToggle />
                </Nav.Item>
              ) : null}

              <Nav.Item className="fork-btn">
                <button
                  className="buttonHome"
                  style={{
                    marginTop: "0px",
                    padding: "0.55rem 1rem",
                    minWidth: "auto",
                    width: isMobile ? "100%" : "auto",
                    marginLeft: isMobile ? "0px" : "10px",
                  }}
                  onClick={() => scrollTo("#book-appointment", appointmentRef)}
                >
                  Book a Call
                </button>
              </Nav.Item>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      {drawer}
    </>
  );
}

export default NavBar;
